export default "__VITE_ASSET__3213e84c__"